import React, { forwardRef } from 'react';

// UniversalLink designed for Next.js (Multiverse) and standard React environments.
// It accepts a LinkComponent prop (e.g., next/link).
// Defaults to standard anchor tag.

export interface UniversalLinkProps {
  LinkComponent?: any;
  href?: string;
  to?: string;
  children: React.ReactNode;
  [key: string]: any;
}

export const UniversalLink = forwardRef<HTMLAnchorElement, UniversalLinkProps>(
  ({ LinkComponent, href, to, children, ...props }, ref) => {
    const destination = to || href || '#';

    // If a specific Link component is passed (e.g. Next.js Link), use it.
    if (LinkComponent) {
      return (
        <LinkComponent href={destination} {...props} ref={ref}>
          {children}
        </LinkComponent>
      );
    }

    // Standard anchor tag fallback
    return (
      <a href={destination} {...props} ref={ref as any}>
        {children}
      </a>
    );
  }
);
